import history from 'utils/history'
import createStore from './createStore'

const initialState = {}
export default createStore(initialState, history)
